<template>
  <div class="incomeList">
    <div class="content">
      <p>{{historyArray.companyName}}</p>
      <div class="bto">
        <ul>
          <li> <span>订单编号&nbsp; &nbsp; </span> {{historyArray.order_no}}</li>
          <li> <span>收益说明&nbsp; &nbsp;  </span> {{historyArray.description}}</li>
          <li> <span>收益时间&nbsp; &nbsp;  </span> {{historyArray.date}}</li>
        </ul>

        <div class="money"><span>￥</span>{{historyArray.bonus}}</div>
      </div>
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    historyArray: Object
  }
}
</script>


<style scoped lang="scss">
.incomeList {
  width: 100%;
  .content {
    width: 100%;
    padding-left: 32px;
    padding-right: 32px;
    box-sizing: border-box;
    border-bottom:1px solid rgb(238,238,238);
    padding-bottom: 16px;
    p {
      margin: 0px;
      font-weight: 400;
      font-size: 14px;
      margin-bottom: 16px;
      margin-top: 16px;
    }
    .bto {
      display: flex;
      justify-content: space-between;
      ul {

        li {
          font-size: 12px;
          color:#888B94 ;
          margin-bottom: 8px;
           span {
        font-size: 12px;
        font-weight: 400;
        color: #BDBEC1;
        margin-bottom: 8px;
      }
        }
      }
      .money {
        span {
          font-size: 12px;
        }
        font-size:20px ;
        color:#EE6236;
      }
    }

  }
}
</style>
